import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from './app/App'
import { AppStateProvider } from './state/AppState'
import { applyStoredTheme } from './state/preferences'
import './styles/theme.css'

// До первого рендера: иначе страница мигнёт светлым, пока React не
// смонтирует кабинет и не применит сохранённый выбор темы.
applyStoredTheme()

const root = document.getElementById('root')
if (root === null) throw new Error('Нет корневого элемента #root')

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <AppStateProvider>
        <App />
      </AppStateProvider>
    </BrowserRouter>
  </StrictMode>
)
